import React, { FC } from 'react';
import { NumberInput } from 'components/forms';
import { FieldRenderProps } from 'react-final-form';

export interface ITextInputWrapper extends FieldRenderProps<string> {
  label: string;
  errorClassname?: string;
}

const NumberInputWrapper: FC<ITextInputWrapper> = (props) => {
  const { input, meta, render, children, ...otherProps } = props;

  return <NumberInput {...input} {...meta} {...otherProps} />;
};

export default NumberInputWrapper;
